/* MQA: prev/next arrows for the featured-collection-slider category tabs.
   Scoped to .featured-collection-slider__navigation-list — no global slider settings touched.
   Arrows appear only when the tab strip actually overflows (scrollable), and each hides at its end. */
(function () {
  function init(list) {
    if (list.__mqaTabs) return;
    list.__mqaTabs = true;

    var wrap = document.createElement('div');
    wrap.className = 'mqa-tabs-wrap';
    list.parentNode.insertBefore(wrap, list);
    wrap.appendChild(list);

    var prev = document.createElement('button');
    var next = document.createElement('button');
    prev.type = next.type = 'button';
    prev.className = 'mqa-tabs-arrow mqa-tabs-prev';
    next.className = 'mqa-tabs-arrow mqa-tabs-next';
    prev.setAttribute('aria-label', 'Scroll categories left');
    next.setAttribute('aria-label', 'Scroll categories right');
    prev.innerHTML = '‹'; // ‹
    next.innerHTML = '›'; // ›
    wrap.appendChild(prev);
    wrap.appendChild(next);

    var step = function () { return Math.max(140, Math.round(list.clientWidth * 0.7)); };
    prev.addEventListener('click', function () { list.scrollBy({ left: -step(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { list.scrollBy({ left: step(), behavior: 'smooth' }); });

    function update() {
      var max = list.scrollWidth - list.clientWidth;
      var scrollable = max > 2;
      wrap.classList.toggle('mqa-tabs-scrollable', scrollable);
      prev.classList.toggle('mqa-tabs-hide', list.scrollLeft <= 1);
      next.classList.toggle('mqa-tabs-hide', list.scrollLeft >= max - 1);
    }
    list.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
    [150, 500, 1200].forEach(function (t) { setTimeout(update, t); }); // re-check after layout/fonts settle
  }

  function run() {
    var lists = document.querySelectorAll('.featured-collection-slider__navigation-list');
    for (var i = 0; i < lists.length; i++) init(lists[i]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();
